<div class="team-leadership-codex-container">
    <p-card>
        <div class="card-header">
            <h2 class="codex-title">{{ 'wo_codex_title' | translate }}</h2>
            <p-dropdown [options]="teamCodexReports" (onChange)="sortCurrentAndPreviousReport($event.value.index)"
                        optionLabel="quarter" dropdownIcon="bi bi-caret-down-fill"
                        styleClass="wo-dropdown" panelStyleClass="wo-dropdown-panel"></p-dropdown>
            <button *ngIf="isUserEligibleToSeeMore" class="codex-see-more-btn" (click)="seeMore()" pButton
                    label="{{ 'team_see_more_button' | translate }}"></button>
        </div>

        <div class="trends-container" *ngIf="currentReport">
            <div class="good-trends-container">
                <div class="row g-4">
                    <div class="col-12">
                        <div class="codex-box" style="justify-content: space-around">
                            <h2 class="wss-title">{{ 'wo_codex_progress_title' | translate }}</h2>
                            <div class="wss-right">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="20 7 100 110" version="1.1"
                                     width="260px" height="260px">
                                    <path class="grey" d="M40,90
                        A40,40 0 1,1 100,90"
                                          style="fill:none;"/>
                                    <path [attr.stroke]="currentReport.score.color"
                                          [attr.stroke-dasharray]="setKnobProgressBar(currentReport.score.value, 'svgProgressTeamCodex')"
                                          id="svgProgressTeamCodex"
                                          class="progress" d="M40,90
                        A40,40 0 1,1 100,90"
                                          style="fill:none;"/>
                                    <path [ngClass]="(currentReport.score.diff.trend === 'up') ? 'svgArrowUp' :
                                        (currentReport.score.diff.trend === 'down') ? 'svgArrowDown' : 'svgArrowEven'"
                                          d="M15.358,9.708l.837-.837a.9.9,0,0,0,0-1.278L8.871.266a.9.9,0,0,0-1.278,0L.266,7.593a.9.9,0,0,0,0,1.278l.837.837A.906.906,0,0,0,2.4,9.693L6.723,5.151V15.984a.9.9,0,0,0,.9.9H8.833a.9.9,0,0,0,.9-.9V5.151l4.327,4.542A.9.9,0,0,0,15.358,9.708Z"></path>
                                    <text class="svgTextValue"
                                          [attr.x]="62"
                                          y="70">{{ currentReport.score.value }}
                                    </text>
                                    <text class="svgTextPercentage"
                                          [attr.x]="83"
                                          y="70">%
                                    </text>
                                </svg>
                            </div>
                            <div class="wss-left">
                                <div class="wss-last-collector">
                                    <span *ngIf="currentReport.score.diff.trend === 'up'">
                                      <img style="margin-bottom: .4rem;"
                                           src="../../../assets/svg/indicator-arrow-up.svg"><b>{{ currentReport.score.diff.value + '% ' }}</b>{{ 'wo_codex_progress_change'|translate }}
                                    </span>
                                    <span *ngIf="currentReport.score.diff.trend === 'down'">
                                      <img style="margin-bottom: .4rem;"
                                           src="../../../assets/svg/indicator-arrow-down.svg"><b>{{ currentReport.score.diff.value + '% ' }}</b>{{ 'wo_codex_progress_change'|translate }}
                                    </span>
                                    <span *ngIf="!currentReport.score.diff.trend"><i
                                      [style]="{'color':'#5e5e5e'}"
                                      class="bi bi-dash-lg"> </i> 0% {{ 'wo_codex_progress_change'|translate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="codex-box" style="display: block; position: relative">
                            <h2 class="w-c-title">{{ 'wo_codex_highest' | translate }}</h2>
                            <div [ngStyle]="{'background-color' : '#F0F3FA', 'border': '1px solid #E4EDFE' }"
                                 class="codex-indicator">
                                <img [ngStyle]="{'background-image': currentReport.highestTopic.gradientColor}"
                                     [src]="'../../../assets/icons/codex/'+ currentReport.highestTopic.category.slug +'.svg'"
                                     class="codex-indicator-image">
                                <span class="codex-indicator-title">{{ currentReport.highestTopic.category.title }}</span>
                                <div class="codex-indicator-percentage-container" [style]="{'background-color':'#FFFFFF'}">
                                    <span class="codex-percentage-value">{{ currentReport.highestTopic.score }}</span>
                                    <span class="percentage">%</span>
                                    <img class="indicator-arrow-img"
                                         *ngIf="currentReport.highestTopic.comparison.trend"
                                         [src]="'../../../assets/svg/indicator-arrow-'+ currentReport.highestTopic.comparison.trend +'.svg'">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="codex-box" style="display: block; position: relative">
                            <h2 class="w-c-title">{{ 'wo_codex_lowest' | translate }}</h2>
                            <div [ngStyle]="{'background-color' : '#F0F3FA', 'border': '1px solid #E4EDFE' }"
                                 class="codex-indicator">
                                <img [ngStyle]="{'background-image': currentReport.lowestTopic.gradientColor}"
                                     [src]="'../../../assets/icons/codex/'+ currentReport.lowestTopic.category.slug +'.svg'"
                                     class="codex-indicator-image">
                                <span class="codex-indicator-title">{{ currentReport.lowestTopic.category.title }}</span>
                                <div class="codex-indicator-percentage-container" [style]="{'background-color':'#FFFFFF'}">
                                    <span class="codex-percentage-value">{{ currentReport.lowestTopic.score }}</span>
                                    <span class="percentage">%</span>
                                    <img class="indicator-arrow-img"
                                         *ngIf="currentReport.lowestTopic.comparison.trend"
                                         [src]="'../../../assets/svg/indicator-arrow-'+ currentReport.lowestTopic.comparison.trend +'.svg'">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </p-card>
</div>
